import styled, { css } from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';
import { ColTypes } from '@/constants/common';

export const gridConfig = (config?: ColTypes, length?: ColTypes) => {
  const renderMedia = (
    query: string,
    cols?: number | string,
    limit?: number | string
  ) => {
    if (!cols && !Number(limit)) return null;

    return css`
      @media (${query}) {
        ${cols &&
        css`
          grid-template-columns: repeat(${cols}, minmax(0, 1fr));
        `}

        ${limit &&
        css`
          & > *:nth-child(n + ${Number(limit) + 1}) {
            display: none;
          }
        `}
      }
    `;
  };

  return css`
    ${renderMedia(
      `min-width: ${BREAKPOINTS.largeDesktop}`,
      config?.largeDesktop,
      length?.largeDesktop
    )}

    ${renderMedia(
      `max-width: ${BREAKPOINTS.desktop}`,
      config?.desktop,
      length?.desktop
    )}

    ${renderMedia(
      `max-width: ${BREAKPOINTS.laptop}`,
      config?.laptop,
      length?.laptop
    )}

    ${renderMedia(
      `max-width: ${BREAKPOINTS.tablet}`,
      config?.tablet,
      length?.tablet
    )}

    ${renderMedia(
      `max-width: ${BREAKPOINTS.mobile}`,
      config?.mobile,
      length?.mobile
    )}
  `;
};

export const ListWrapper = styled.div<{
  $cols?: ColTypes;
  $length?: ColTypes;
}>`
  width: 100%;
  height: fit-content;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(296px, 1fr));
  gap: 20px;
  padding: 20px 0 0;

  & > * {
    min-width: 0;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    grid-template-columns: 1fr;
  }

  ${({ $cols, $length }) => gridConfig($cols, $length)}
`;
